// eslint-disable-next-line import/no-extraneous-dependencies
import Vue from 'vue';
import PrismicVue from '@prismicio/vue';
import linkResolver from '@/utils/prismic/link-resolver';

Vue.use(PrismicVue, {
  endpoint: process.env.NUXT_ENV_PRISMIC_BLOCKS_ENDPOINT,
  linkResolver,
});
